import { i18n } from '@lt/localization';

export const TITLE = i18n.t('hotel.IncludedinPrice');
